import React, { memo } from 'react';
import RingLoader from 'react-spinners/RingLoader';
const RingSpinner = (props: RingSpinnerProps) => {
  const { isLoading, style } = props;
  return (
    <>
      {isLoading && (
        <div
          className={`z-[100000] fixed translate-x-[-50%]  top-0 left-2/4 m-auto bg-col-black-0_7 h-[100vh] w-[100vw] rounded flex justify-center items-center ${style}`}
        >
          <div className="flex">
            <RingLoader color="#7E3F7C" loading={isLoading} size={100} />
          </div>
        </div>
      )}
    </>
  );
};

export default memo(RingSpinner);
type RingSpinnerProps = {
  isLoading: boolean;
  style?: string;
};
